(function () {
	'use strict';

	angular.module('qbePortal').controller('QBValidationController', QBValidationController);

	QBValidationController.$inject = ['$scope', 'validationService'];

	function QBValidationController($scope, validationService) {
		var vm = this, scope = $scope, validationMessages = {};

		var hasErrors = false, errors = {};

		var validationResult = null;

		// $scope.$on('field-error', onError);
		$scope.validationSelector = vm.validationSelector;
		// function onError (event, error) {
		// 	var currentFieldSelector = error.section + '.' + error.inputName ;
		// 	//console.log(vm.validationSelector + ' | ' + currentFieldSelector);
		// 	if (vm.validationSelector == currentFieldSelector ) {
		// 		hasErrors = true ;
		// 		errors[error.type] = error ;
		// 		console.log('field has error') ;
		// 		$scope.$emit('enable-field-error-class') ;
		// 	}
		// }

		vm.validationMessageFor = function (rule) {
			// if ( ! validationResult )
			validationResult = validationService.getFieldErrors(vm.validationSelector);
			return validationResult ? validationResult.errors[rule] : null;
		}

		vm.isInvalid = function (rule) {
			return validationService.isFieldInvalid(vm.validationSelector, rule); //, vm.messageKey) ;
			// return validationResult[rule] ;
		}
	}

	angular.module('qbePortal').component('qbValidation', {
		templateUrl: '/ngviews/components/qbValidation.html',
		controller: QBValidationController,
		controllerAs: 'vm',
		bindings: {
			validationSelector: '<',
			messageKey: '<',
		}
	});
})();
